import clsx from 'clsx'

import { useCalculateMileageLoss } from '../hooks/useCalculateMileageLoss'
import { formatNumber } from '@/helpers/formatNumber'
import { LinkButton } from '@/ui/Button'
import { ROUTES } from '@/router'

import CalendarIcon from '../assets/calendar-icon.svg'
import styles from './Mileage.module.scss'

import DisruptionsIcon from '../assets/disruption-icon.svg'
import BusIcon from '../assets/bus-icon.svg'
import { useLocation } from 'react-router-dom'

interface Props {
    displayed: boolean
}

export const Mileage = ({ displayed }: Props) => {
    const mileageLoss = useCalculateMileageLoss()
    const { pathname } = useLocation()

    const isSharedLogPage = pathname.includes(ROUTES.SHARED_LOG)

    if (!displayed) {
        return <></>
    }

    return (
        <section className={styles.root}>
            <div className={styles.badgeContainer}>
                {Object.entries(mileageLoss).map(([key, value]) => (
                    <div key={key} className={clsx(styles.badge, styles[`badge${key}`])}>
                        <span className={styles.label}>{key}</span>
                        <span className={styles.value}>{formatNumber(value)}</span>
                    </div>
                ))}
            </div>
            {!isSharedLogPage && (
                <div className={styles.actions}>
                    <LinkButton to={ROUTES.CONTROL_SHEET} variant="tertiary" size="small" className={styles.action}>
                        <CalendarIcon />
                        Control sheet
                    </LinkButton>
                    <LinkButton to={ROUTES.DISRUPTIONS} variant="tertiary" size="small" className={styles.action}>
                        <DisruptionsIcon />
                        Disruptions
                    </LinkButton>
                    <LinkButton
                        to={ROUTES.VEHICLE_ALLOCATION}
                        variant="tertiary"
                        size="small"
                        className={styles.action}
                    >
                        <BusIcon />
                        Vehicle allocation
                    </LinkButton>
                </div>
            )}
        </section>
    )
}
